export const phoneNumber = "0 212 252 94 49";
